import React from 'react'

import { Flex, Header } from '@driftt/dds'

interface NavigationTabsProps {
  activeTab: string
  tabNames: string[]
  onTabSelected: (selectedTab: string) => void
}

const NavigationTabs = ({ activeTab, tabNames, onTabSelected }: NavigationTabsProps) => {
  return (
    <Flex css={{ paddingTop: '$2', paddingBottom: '$0' }} gap={4}>
      {tabNames.map(tabName => (
        <Header
          variant="h3"
          css={{
            cursor: 'pointer',
            color: tabName === activeTab ? '$gray11' : '$gray8',
            borderBottom: tabName === activeTab ? '2px solid $gray11' : 'none',
            paddingBottom: '$1'
          }}
          key={tabName}
          onClick={() => onTabSelected(tabName)}>
          {tabName}
        </Header>
      ))}
    </Flex>
  )
}

export default NavigationTabs
